import { Map } from 'immutable';
import { isServerSideRendering } from '@dbh/environment';
import { F as FRONT_END_LOGIC_REDIRECT_TRIGGERED } from './index-5b1a6080.js';
export { R as REDUX_AND_SAGA_KEY } from './index-5b1a6080.js';
import 'prop-types';
import '@dbh/generic-types';
import '@dbh/with-conforms-to-for-production-www';

const initialState=Map({redirectTo:void 0,statusCode:void 0,redirectLogic:void 0,redirectToUrlOfWebpagesRoute:void 0}),ssrFrontEndLogicRedirectReducer=function(a,b){void 0===a&&(a=initialState);const{payload:c,type:d}=b;return d===FRONT_END_LOGIC_REDIRECT_TRIGGERED?isServerSideRendering()?Map(c):a:a};

export { ssrFrontEndLogicRedirectReducer as default };
